import { useEffect, useState } from 'react';
import Collapse from '@components/Collapse';
import WarningIcon from '@assets/images/exclamation-triangle.svg';
import { LocalStorageKey } from '@constants/storage-keys.constants';

interface MaintenanceNoticeProps {
	title: string;
	message: string;
}

const NoticeHeader = ({ title }: { title: string }) => (
	<div className='flex items-center'>
		<WarningIcon />
		<p className='ml-2 text-yellow-dark text-base'>{title}</p>
	</div>
);

const NoticeContent = ({ message }: { message: string }) => (
	<div className='px-6 pt-0 pb-2 ml-6'>
		<div className='text-yellow-dark'>{message}</div>
	</div>
);

export default function MaintenanceNotice({ title, message }: MaintenanceNoticeProps) {
	const [isNoticeExpand, setIsNoticeExpand] = useState(() => {
		const stored = window.localStorage.getItem(LocalStorageKey.EXPAND_MAINTENANCE_NOTICE);
		return stored ? JSON.parse(stored) : true;
	});

	useEffect(() => {
		window.localStorage.setItem(LocalStorageKey.EXPAND_MAINTENANCE_NOTICE, JSON.stringify(isNoticeExpand));
	}, [isNoticeExpand]);

	return (
		<div className='bg-yellow-pale'>
			<Collapse isOpen={isNoticeExpand} setIsOpen={setIsNoticeExpand} topPadding='py-2' header={<NoticeHeader title={title} />}>
				<NoticeContent message={message} />
			</Collapse>
		</div>
	);
}
